<template>
	<div class="ttshop_sing">
		<Singinheader :headertext="texted"></Singinheader>
		<div class="ttshop_singcon" :style="backgroundimg">
			<div class="ttshop_singconter w">
				<div class="ttshop_singrights" v-if="hiddens">
					<div class="ttshop_singnav">
						<ul class="clearfloat">
							<!-- <li :class="{active: 0 == num}" @click="table(0)">短信登陆</li> -->
							<li :class="{ active: 1 == num }" @click="table(1)">账户登陆</li>
						</ul>
						<div class="ttshop_wx" @click="scan()" v-if="false">
							<img class="img-default" src="../../assets/images/ttshop_wx.png" alt />
						</div>
					</div>
					<div class="ttshop_singincon">
						<!-- 短信登陆 -->
						<div class="ttshop_singlist" v-show="num == 0">
							<!-- 错误提示 -->
							<div class="ttshop_singtop" :class="{ ttshop_singtop_active: iShow }">
								<p>
									<i>
										<img class="img-default" src="../../assets/images/ttshop_samil.png" alt />
									</i>
									<span>{{ title }}</span>
								</p>
							</div>
							<ul>
								<li>
									<input type="text" placeholder="手机号登陆" v-model="mobile" ref="mobile" maxlength="11"
										v-on:input="animateWidth()" class="ttshop_input" />
								</li>
								<li>
									<input type="text" v-model="mobileCode" ref="mobileCode" placeholder="手机验证码"
										class="ttshop_mobileyz" autocomplete="new-password" />
									<template v-if="show">
										<div class="ttshop_yzm d-flex align-items-center justify-content-center" v-if="success" @click="getCode">
											获取验证码
										</div>
										<div class="ttshop_yzm d-flex align-items-center justify-content-center" v-else>
											获取验证码
										</div>
									</template>
									<template v-if="!show">
										<div class="ttshop_yzm d-flex align-items-center justify-content-center">
											{{ count }}秒后重新发送
										</div>
									</template>
								</li>
								<li class="ttshop_forget">
									<p @click="goPassword">忘记密码?</p>
								</li>
								<li>
									<button class="ttshop_singbutton" @click="codeLogin">
										登陆
									</button>
								</li>
								<li>
									<router-link to="/register">没有账号，免费注册</router-link>
								</li>
							</ul>
						</div>
						<!-- 账户登陆 -->
						<div class="ttshop_singlist" v-show="num == 1">
							<!-- 错误提示 -->
							<div class="ttshop_singtop" :class="{ ttshop_singtop_active: pwShow }">
								<p>
									<i>
										<img class="img-default" src="../../assets/images/ttshop_samil.png" alt />
									</i>
									<span>{{ pwTitle }}</span>
								</p>
							</div>
							<ul>
								<li>
									<input type="text" ref="name" v-model="name" placeholder="请输入账户"
										class="ttshop_input" />
								</li>
								<li>
									<input type="password" autocomplete="off" style="display: none" />
									<input :type="inputtype" ref="password" @focus="inputtype = 'password'"
										v-model="password" placeholder="请输入登录密码" class="ttshop_password"
										autocomplete="new-password" />
								</li>
								<!-- <li class="ttshop_forget">
									<p @click="goPassword">忘记密码?</p>
								</li> -->
								<li>
									<el-button  class="ttshop_singbutton" @click="passwordLogin" :loading="PcLoading">登录</el-button>
								</li>
								<!-- <li>
									<router-link to="/register" replace>没有账号，免费注册</router-link>
								</li> -->
							</ul>
						</div>
					</div>
				</div>
				<div class="ttshop_singrights" v-show="!hiddens">
					<div class="ttshop_scan">
						<p>手机扫码，安全登录</p>
					</div>
					<div class="ttshop_wxer" @click="scan()">
						<img class="img-default" src="../../assets/images/ttshop_zh.png" alt />
					</div>
					<div id="login_container"></div>
					<div class="ttshop_codeimg">
						<img class="img-default" src="../../assets/images/ttshop_ewm.png" alt />
					</div>
					<div class="ttshop_codetext">
						<p>
							使用微信扫描二维码
							<br />即可注册或登录
						</p>
					</div>
				</div>
			</div>
			<!-- 图片验证 -->
			<div class="ttshop_yanzheng" v-show="verify">
				<div class="ttshop_yanzhengbj"></div>
				<div class="ttshop_yanzhengbox">
					<slide-verify ref="slideblock" @success="onSuccess" @again="onAgain" @fulfilled="onFulfilled"
						@fail="onFail" @refresh="onRefresh" :slider-text="text" :imgs="imgs"
						:accuracy="accuracy"></slide-verify>
					<div class="ttshop_yanzhengclose" @click="closeVerify">
						<img class="img-default" src="../../assets/images/ttshop_colse.png" alt="" />
					</div>
				</div>
			</div>
		</div>
		<Foot :footerhidden="false"></Foot>
	</div>
</template>

<script>
	import Singinheader from "./components/singinheader";
	import Foot from "@/components/foot/foot";

	import img0 from "../../assets/images/img.jpg";
	import img1 from "../../assets/images/img1.jpg";
	import img2 from "../../assets/images/img2.jpg";
	import img3 from "../../assets/images/img3.jpg";
	import img4 from "../../assets/images/img4.jpg";
	import img5 from "../../assets/images/img5.jpg";
	import {
		Base64
	} from "js-base64";
	import md5 from "js-md5";

	export default {
		components: {
			Singinheader,
			Foot,
		},
		data() {
			return {
				PcLoading:false,
				texted: "欢迎登录",
				backgroundimg: {
					backgroundImage: "",
				},
				num: 1,
				hiddens: true,
				msg: "",
				text: "向右滑动->",
				imgs: [img0, img1, img2, img3, img4, img5],
				accuracy: 5, // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
				verify: false,
				iShow: false,
				title: "",
				pwShow: false,
				pwTitle: "",
				mobile: "",
				mobileCode: "",
				show: true,
				success: false,
				timer: null,
				count: "",
				name: "",
				password: "",
				state: "", //扫码登录验证
				wx_login_check: null,
				inputtype: "text",
			};
		},
		created() {
			// if (this.$store.state.user) {
			//   let token = this.$store.state.user.access_token;
			//   let redirect = "/homepage";
			//   this.$router.replace(redirect);
			// }
			this.yanzhengtoken();
			//登录添加键盘事件,注意,不能直接在焦点事件上添加回车
			this.store();
			let that = this;
			document.onkeydown = function(e) {
				let key = window.event.keyCode;
				if (key === 13) {
					if (that.num == 0) {
						that.codeLogin();
					} else {
						that.passwordLogin();
					}
				}
			};
			// this.getQrcode();
		},
		methods: {
			getUrlOption() {
				let str = location.search.substr(1).split("&");
				let obj = {};
				str.forEach((e) => {
					let list = e.split("=");
					obj[list[0]] = list[1];
				});
				return obj;
			},
			yanzhengtoken() {
				let _this = this;
				let accessToken = this.getUrlOption().accessToken ||
					this.$route.query.accessToken || this.$route.params.accessToken;
				if (!accessToken) {
					return false
				}
				_this.$api
					.pcLogin({
						accessToken: accessToken,
					})
					.then((res) => {
						console.log(res);
						if (res.code == 0) {
							_this.$store.commit("userInfo", res.data);
							const redirect = _this.$route.query.redirect || "/homepage";
							_this.$router.replace(redirect);
						}
					})
					.catch((err) => {
						console.log(err);
						_this.common.message(_this, err);
					});
			},
			// 获取微信二维码
			getQrcode() {
				this.$api
					.wxLogin()
					.then((res) => {
						console.log(res);
						this.state = res.data.state;
						var obj = new WxLogin({
							self_redirect: true,
							id: "login_container",
							appid: res.data.appId,
							scope: res.data.scope,
							redirect_uri: res.data.redirect_uri,
							state: res.data.state,
							style: "black",
							href: "https://ttshop.oeob.net/statics/css/wxqrcode.css",
						});
						this.wx_login_check = setInterval(() => {
							this.wxLoginCheck();
						}, 3000);
					})
					.catch((err) => {
						console.log(err);
					});
			},
			wxLoginCheck() {
				let params = {
					state: this.state,
				};
				this.$api
					.wxLoginCheck(params)
					.then((res) => {
						this.$store.commit("userInfo", res.data);
						const redirect = this.$route.query.redirect || "/homepage";
						this.$router.replace(redirect);
					})
					.catch((err) => {
						if (err.code == 2) {
							console.log(err);
							// return false
							this.$router.replace("/binding");
						}
					});
			},
			// 获取商城配置
			store() {
				this.$api
					.store({})
					.then((res) => {
						if (res.data.store.pc_back_logo) {
							this.backgroundimg = {
								backgroundImage: "url(" + res.data.store.pc_back_logo + ")",
							};
						}
					})
					.catch((err) => {
						console.log(err);
					});
			},
			// 忘记密码
			goPassword() {
				this.$router.push("/password");
			},
			//账号密码登录
			passwordLogin() {
				let _this = this;
				let name = this.$refs.name.value;
				let password = this.$refs.password.value;
				if (name == "") {
					_this.pwTitle = "请输入用户名";
					_this.pwShow = true;
				} else if (password == "") {
					_this.pwTitle = "请输入密码";
					_this.pwShow = true;
				} else {
					this.PcLoading = true;
					_this.pwShow = false;
					_this.$api.pcLogin({
							username: name,
							password: password,
						}).then((res) => {
							if (res.code == 0 || res.code == 200) {
								this.PcLoading = false;
								this.$store.commit("userInfo", res.data);
								const redirect = this.$route.query.redirect || "/homepage";
								this.$router.replace(redirect);
							} else {
								this.PcLoading = false;
								_this.pwTitle = res.msg;
								_this.pwShow = true;
							}

						}).catch((err) => {
							console.log(err);
							this.PcLoading = false;
							_this.pwTitle = err.msg;
							_this.pwShow = true;
						});
				}
			},
			// 获取验证码
			getCode() {
				if (this.success) {
					this.verify = true;
				} else {
					this.title = "请输入正确手机号";
					this.iShow = true;
				}
			},
			// 手机号失焦事件
			animateWidth() {
				let _this = this;
				let num = _this.$refs.mobile.value;
				if (num == "") {
					_this.iShow = false;
					return;
				}
				if (num.length == 11) {
					if (!/^1[3456789]\d{9}$/.test(num)) {
						_this.title = "请输入正确手机号";
						_this.iShow = true;
					} else {
						_this.$api
							.whether({
								mobile: num,
							})
							.then((res) => {
								if (res.data) {
									_this.title = "用户不存在";
									_this.iShow = true;
									_this.success = false;
								} else {
									_this.iShow = false;
									_this.success = true;
								}
							})
							.catch((err) => {
								console.log(err);
							});
						_this.iShow = false;
						_this.success = true;
					}
				} else {
					_this.iShow = false;
				}
			},
			//获取验证码
			resSale() {
				let _this = this;
				let phone_number = _this.$refs.mobile.value;
				var time = Date.parse(new Date()) / 1000;
				this.dateFormat("y*m=dh&i#s", new Date());
				console.log(this.formatStr);
				var date = _this.formatStr;
				var first = phone_number.substr(1, 4);
				var end = phone_number.substr(phone_number.length - 4);
				var sign = Base64.encode(md5(first + date + end + phone_number + time));
				_this.$api
					.resSale({
						mobile: phone_number,
						sign_time: time,
						sign: sign,
					})
					.then((res) => {
						_this.$api
							.sendCode({
								mobile: phone_number,
								token: res.data.token,
							})
							.then((res) => {
								const TIME_COUNT = 60;
								if (!this.timer) {
									this.count = TIME_COUNT;
									this.show = false;
									this.timer = setInterval(() => {
										if (this.count > 0 && this.count <= TIME_COUNT) {
											this.count--;
										} else {
											this.show = true;
											clearInterval(this.timer);
											this.timer = null;
										}
									}, 1000);
								}
							})
							.catch((err) => {
								this.common.message(this, err);
							});
					})
					.catch((err) => {
						console.log(err);
					});
			},
			dateFormat(formatStr, fdate) {
				var fTime,
					fStr = "ymdhis";
				if (!formatStr) formatStr = "y/m/d-h:i:s";
				if (fdate) {
					fTime = new Date(fdate);
				} else {
					fTime = new Date();
				}
				var formatArr = [
					fTime.getFullYear().toString(),
					(fTime.getMonth() + 1).toString() < 10 ?
					"0" + (fTime.getMonth() + 1).toString() :
					(fTime.getMonth() + 1).toString(),
					fTime.getDate().toString() < 10 ?
					"0" + fTime.getDate().toString() :
					fTime.getDate().toString(),
					fTime.getHours().toString() < 10 ?
					"0" + fTime.getHours().toString() :
					fTime.getHours().toString(),
					fTime.getMinutes().toString() < 10 ?
					"0" + fTime.getMinutes().toString() :
					fTime.getMinutes().toString(),
					fTime.getSeconds().toString() < 10 ?
					"0" + fTime.getSeconds().toString() :
					fTime.getSeconds().toString(),
				];
				for (var i = 0; i < formatArr.length; i++) {
					formatStr = formatStr.replace(fStr.charAt(i), formatArr[i]);
				}
				this.formatStr = formatStr;
			},
			//验证码登录
			codeLogin() {
				let _this = this;
				let mobile = _this.$refs.mobile.value;
				let mobileCode = _this.$refs.mobileCode.value;
				if (mobile == "") {
					_this.title = "请输入手机号";
					_this.iShow = true;
				} else if ((mobileCode = "")) {
					_this.title = "请输入验证码";
					_this.iShow = true;
				} else {
					_this.iShow = false;
					_this.pcLogin();
				}
			},
			// 验证码密码登录切换
			table(index) {
				if (this.num != index) {
					this.num = index;
					this.mobile = "";
					this.mobileCode = "";
					this.name = "";
					this.password = "";
					this.iShow = false;
					this.pwShow = false;
				}
			},
			// 二维码切换
			scan() {
				this.hiddens = !this.hiddens;
			},
			cancel: function() {
				// this.$router.replace(this.$route.query.redirect);
				this.$router.go(-1);
			},
			destroyed() {
				window.removeEventListener("popstate", this.cancel, false);
			},
			//关闭图形验证
			closeVerify() {
				this.verify = false;
			},
			// 图形验证
			onSuccess(times) {
				this.msg = `login success, 耗时${(times / 1000).toFixed(1)}s`;
				this.verify = false;
				this.resSale();
				this.handleClick();
			},
			onFail() {
				console.log("验证不通过");
				this.msg = "";
			},
			onRefresh() {
				console.log("点击了刷新小图标");
				this.msg = "";
			},
			onFulfilled() {
				console.log("刷新成功啦！");
			},
			onAgain() {
				console.log("检测到非人为操作的哦！");
				this.msg = "try again";
				// 刷新
				this.handleClick();
			},
			handleClick() {
				this.$refs.slideblock.reset();
				this.msg = "";
			},
			//验证码登录接口
			pcLogin() {
				let _this = this;
				_this.$api
					.pcLogin({
						mobile: _this.$refs.mobile.value,
						mobile_code: _this.$refs.mobileCode.value,
					})
					.then((res) => {
						_this.$store.commit("userInfo", res.data);
						const redirect = _this.$route.query.redirect || "/homepage";
						_this.$router.replace(redirect);
					})
					.catch((err) => {
						console.log(err);
						// _this.title = err.msg;
						// _this.iShow = true;
						_this.common.message(_this, err);
					});
			},
		},
		// 清除计时器
		destroyed() {
			clearTimeout(this.wx_login_check);
		},
	};
</script>

<style lang="scss" scoped>
	.ttshop_singtop_active {
		opacity: 1 !important;
	}

	.ttshop_sing {
		width: 100%;

		.ttshop_singcon {
			width: 100%;
			height: 500px;
			background: #ff0e25;

			.ttshop_singconter {
				height: 500px;
				background-position: left center;
				background-repeat: no-repeat;
				position: relative;

				.ttshop_singrights {
					width: 350px;
					height: 380px;
					background: #fff;
					position: absolute;
					top: 60px;
					right: 0;
					border-radius: 4px;

					.ttshop_singnav {
						width: 100%;
						padding-top: 32px;
						padding-left: 24px;
						box-sizing: border-box;
						position: relative;

						ul {
							li {
								float: left;
								padding-bottom: 8px;
								font-size: 16px;
								color: #666;
								line-height: 16px;
								font-weight: 600;
								margin-right: 16px;
								cursor: pointer;
								transition: 0.5s;
								-moz-transition: 0.5s;
								-webkit-transition: 0.5s;
								-o-transition: 0.5s;
								position: relative;

								&:last-child {
									margin-right: 0;
								}

								&::before {
									content: "";
									width: 0%;
									height: 2px;
									background: #ff0e25;
									position: absolute;
									bottom: -2px;
									left: 50%;
									transform: translateX(-50%);
									-moz-transform: translateX(-50%);
									-webkit-transform: translateX(-50%);
									-o-transform: translateX(-50%);
									transition: 0.5s;
									-moz-transition: 0.5s;
									-webkit-transition: 0.5s;
									-o-transition: 0.5s;
								}

								&:hover {
									color: #ff0e25;
								}

								&:hover:before {
									width: 100%;
								}

								&.active {
									color: #ff0e25;
								}

								&.active:before {
									width: 100%;
								}
							}
						}

						.ttshop_wx {
							width: 56px;
							height: 56px;
							position: absolute;
							top: 6px;
							right: 6px;
							cursor: pointer;

							img {
								display: block;
							}
						}
					}

					.ttshop_singincon {
						width: 100%;
						padding: 0 24px;
						box-sizing: border-box;

						.ttshop_singlist {
							width: 100%;

							.ttshop_singtop {
								width: 100%;
								height: 30px;
								background: #fff0f1;
								padding: 0 15px;
								line-height: 30px;
								margin: 8px 0;
								box-sizing: border-box;
								opacity: 0;

								p {
									i {
										display: inline-block;
										width: 12px;
										height: 12px;
										border-radius: 50%;
										margin-right: 6px;
										vertical-align: -2px;

										img {
											display: block;
											width: 100%;
											height: 100%;
											border-radius: 50%;
										}
									}

									span {
										font-size: 12px;
										color: #ff0e25;
									}
								}
							}

							ul {
								width: 100%;

								li {
									width: 100%;
									position: relative;
									margin-bottom: 24px;

									input {
										width: 100%;
										height: 40px;
										font-size: 12px;
										color: #333;
										padding: 0 41px;
										box-sizing: border-box;
										border: 1px solid #ebebeb;
										border-radius: 2px;
										outline: none;
										transition: 0.5s;
										-moz-transition: 0.5s;
										-webkit-transition: 0.5s;
										-o-transition: 0.5s;

										&:focus {
											border-color: #ff0e25;
										}
									}

									.ttshop_input {
										background: url(../../assets/images/ttshop_mobiles.png) 10px center no-repeat;
									}

									.ttshop_mobileyz {
										padding-right: 110px;
										background: url(../../assets/images/ttshop_yz.png) 11px center no-repeat;
									}

									.ttshop_password {
										background: url(../../assets/images/ttshop_password.png) 11px center no-repeat;
									}

									.ttshop_yzm {
										// display: block;
										min-width: 98px;
										height: 38px;
										border: 0;
										outline: none;
										font-size: 12px;
										color: #333;
										border: 0;
										background: #eeeeee;
										position: absolute;
										top: 1px;
										right: 1px;
										border-radius: 0 2px 2px 0;
										cursor: pointer;
									}

									p {
										display: table;
										font-size: 12px;
										color: #666;
										transition: 0.5s;
										-moz-transition: 0.5s;
										-webkit-transition: 0.5s;
										-o-transition: 0.5s;
										cursor: pointer;

										&:hover {
											color: #ff0e25;
										}
									}
									.ttshop_singbutton {
										width: 100%;
										height: 40px;
										font-size: 14px;
										color: #fff !important;
										border: 0;
										outline: none;
										border-radius: 2px;
										cursor: pointer;
										background: linear-gradient(90deg, #ff9010, #ff0e25);
										background: -moz-linear-gradient(90deg, #ff9010, #ff0e25);
										background: -webkit-gradient(90deg, #ff9010, #ff0e25);
										background: -ms-linear-gradient(90deg, #ff9010, #ff0e25);
										filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#FF9010, endColorstr=#FF0E25);
										transition: 0.5s;
										-moz-transition: 0.5s;
										-webkit-transition: 0.5s;
										-o-transition: 0.5s;
										::v-deep span{color: #fff !important;font-size: 14px;}

										&:hover {
											box-shadow: 0 5px 10px rgba(215, 119, 8, 0.5);
										}
									}

									a {
										font-size: 12px;
										color: #ff0e25;
										display: table;
										margin: 0 auto;
										text-align: center;
									}
								}

								.ttshop_forget {
									margin-bottom: 16px;
								}
							}
						}
					}

					// 二维码登录
					.ttshop_scan {
						width: 100%;
						padding-left: 24px;
						padding-top: 32px;
						box-sizing: border-box;
						margin-bottom: 30px;

						p {
							font-size: 16px;
							color: #666;
							font-weight: 600;
							line-height: 16px;
						}
					}

					.ttshop_codeimg {
						width: 170px;
						height: 170px;
						background: #fff;
						border-radius: 4px;
						box-shadow: 0px 0px 20px 0px rgba(36, 37, 39, 0.12);
						margin: 0 auto 40px;
						padding: 14px;
						box-sizing: border-box;

						img {
							display: block;
							width: 142px;
							height: 142px;
						}
					}

					.ttshop_codetext {
						width: 100%;
						padding: 0 24px;
						box-sizing: border-box;

						p {
							font-size: 12px;
							color: #666;
							text-align: center;
							font-weight: 400;
							line-height: 18px;
						}
					}

					.ttshop_wxer {
						width: 56px;
						height: 56px;
						position: absolute;
						top: 6px;
						right: 6px;
						cursor: pointer;

						img {
							display: block;
						}
					}
				}
			}

			.ttshop_yanzheng {
				width: 100%;
				height: 100%;
				position: fixed;
				top: 0;
				left: 0;
				z-index: 1000;

				.ttshop_yanzhengbj {
					width: 100%;
					height: 100%;
					position: fixed;
					top: 0;
					left: 0;
					background: rgba(0, 0, 0, 0.4);
				}

				.ttshop_yanzhengbox {
					position: fixed;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					padding: 20px;
					box-sizing: border-box;
					background: #fff;
					border-radius: 8px;

					.ttshop_yanzhengclose {
						height: 12px;
						width: 12px;
						position: absolute;
						top: 5px;
						right: 5px;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>